import { render, staticRenderFns } from "./StatisticsRegion.vue?vue&type=template&id=2ab044d7"
import script from "./StatisticsRegion.vue?vue&type=script&lang=js"
export * from "./StatisticsRegion.vue?vue&type=script&lang=js"
import style0 from "./StatisticsRegion.vue?vue&type=style&index=0&id=2ab044d7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports